export const environment = {
  production: true,
  apiUrl: 'https://api.atd-plattform.netzdenke.dev/api'
};